// ChangePassword.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { changePassword } from '../services/auth';
import { ChevronLeft, Lock } from '../components/common/icons';

const ChangePassword: React.FC = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // 基本驗證
    if (!currentUser || !currentUser.email) {
      setError('請先登入');
      return;
    }
    
    if (newPassword !== confirmPassword) {
      setError('新密碼與確認密碼不符');
      return;
    }
    
    if (newPassword.length < 6) {
      setError('新密碼至少需要6個字符');
      return;
    }
    
    setLoading(true);
    setError(null);
    
    try {
      await changePassword(currentPassword, newPassword);
      // 成功後導向個人資料頁面
      navigate('/profile', { state: { success: '密碼已成功更新!' } });
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : '更改密碼失敗');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="max-w-lg mx-auto p-4">
      {/* 返回按鈕 */}
      <button 
        onClick={() => navigate('/profile')}
        className="mb-4 flex items-center text-sky-600 hover:text-sky-700"
      >
        <ChevronLeft size={16} className="mr-1" />
        返回個人資料
      </button>
      
      <div className="p-4 bg-white rounded-xl shadow-sm">
        <h1 className="text-2xl font-semibold mb-6 flex items-center">
          <Lock className="mr-2" size={24} />
          變更密碼
        </h1>
        
        {error && (
          <div className="mb-4 p-3 bg-error-100 text-error-700 rounded-md">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="currentPassword" className="block text-sm font-medium mb-1">
              當前密碼
            </label>
            <input
              type="password"
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="w-full p-2 border border-neutral-300 rounded-md"
              required
            />
          </div>
          
          <div>
            <label htmlFor="newPassword" className="block text-sm font-medium mb-1">
              新密碼
            </label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full p-2 border border-neutral-300 rounded-md"
              minLength={6}
              required
            />
          </div>
          
          <div>
            <label htmlFor="confirmPassword" className="block text-sm font-medium mb-1">
              確認新密碼
            </label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full p-2 border border-neutral-300 rounded-md"
              minLength={6}
              required
            />
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-brand-blue text-white py-2 px-4 rounded-md hover:bg-sky-600 transition-colors disabled:bg-neutral-400"
          >
            {loading ? '處理中...' : '更新密碼'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;